import { LoginComponent } from "../lib/auth/login/login.component";
import { alreadyLoggedGuard, authGuard } from "@teammood/shared/util/core";
import { LogoutComponent } from "../lib/auth/logout/logout.component";
import { AddCommentComponent } from "../lib/add-feedback/add-comment/add-comment.component";
import { AddOtherFeedbackComponent } from "../lib/add-feedback/add-other-feedback/add-other-feedback.component";
import { AddPollCommentComponent } from "../lib/add-feedback/add-poll-comment/add-poll-comment.component";
import { AboutYouComponent } from "../lib/onboarding/aboutyou/aboutyou.component";
import { InvalidTokenComponent } from "../lib/onboarding/token/invalid-token/invalid-token.component";
import { RenewedTokenComponent } from "../lib/onboarding/token/renewed-token/renewed-token.component";
import { ExpiredTokenComponent } from "../lib/onboarding/token/expired-token/expired-token.component";
import { AlreadyInTeamComponent } from "../lib/onboarding/token/already-in-team/already-in-team.component";
import { DefaultSettingsComponent } from "../lib/onboarding/default-settings/default-settings.component";
import { TeamMembersComponent } from "../lib/onboarding/team-members/team-members.component";
import { ReadyComponent } from "../lib/onboarding/ready/ready.component";
import { MainComponent } from "../lib/main/main.component";
import { UserHomeComponent } from "../lib/main/userhome.component";
import { TimelineComponent } from "../lib/timeline/timeline.component";
import { StatsComponent } from "../lib/analytics/stats/stats.component";
import { ReportingComponent } from "../lib/reporting/reporting.component";
import { ExportsComponent } from "../lib/exports/exports.component";
import { CalendarComponent } from "../lib/calendar/calendar.component";
import { TeamMembersSetupComponent } from "../lib/setup/team-members-setup/team-members-setup.component";
import { TeamSetupComponent } from "../lib/setup/team-setup/team-setup.component";
import { PollsSetupComponent } from "../lib/polls/polls-setup.component";
import { DigestsComponent } from "../lib/setup/digests/digests.component";
import { FiltersComponent } from "../lib/setup/filters/filters.component";
import { OutOfOfficeSettingsComponent } from "../lib/setup/out-of-office/out-of-office-settings.component";
import { AccountService } from "../lib/setup/account/account.service";
import { inject } from "@angular/core";
import { AccountSetupComponent } from "../lib/setup/account/account-setup.component";
import { IntegrationsComponent } from "../lib/setup/integrations/integrations.component";
import { NotificationDaysComponent } from "../lib/setup/notification-days/notification-days.component";
import { NotificationTimeSettingsComponent } from "../lib/setup/notification-time/notification-time.component";
import { ApiKeysComponent } from "../lib/api-keys/api-keys.component";
import { BillingHistoryComponent } from "../lib/billing/billing-history/billing-history.component";
import { EmailDeliveryComponent } from "../lib/troubleshoot/email-delivery/email-delivery.component";
import {
    EmailDeliveryStatusComponent
} from "../lib/troubleshoot/email-delivery-status/email-delivery-status.component";
import { CreditCardComponent } from "../lib/billing/credit-card/credit-card.component";
import { PaymentValidatedComponent } from "../lib/billing/payment-validated/payment-validated.component";
import { PaymentFailedComponent } from "../lib/billing/payment-failed/payment-failed.component";
import { ErrorMessageComponent } from "../lib/error-message/error-message.component";
import { Routes } from "@angular/router";
import { TaskbookBacklogComponent } from "../lib/taskbook-backlog/taskbook-backlog.component";
import { TaskbookTriageComponent } from "../lib/taskbook-triage/taskbook-triage.component";
import { TaskDetailsComponent } from "../lib/taskbook-backlog/task-details/task-details.component";
import { ChooseMoodComponent } from "../lib/add-feedback/choose-mood/choose-mood.component";
import { YearlyBillingComponent } from "../lib/billing/yearly-billing/yearly-billing.component";
import {
    YearlyBillingDetailsByTeamComponent
} from "../lib/billing/yearly-billing/yearly-billing-details-by-team.component";

export const APP_ROUTES: Routes = [
    { path: 'login', component: LoginComponent, canActivate: [alreadyLoggedGuard()]}, // go to /home is authed
    { path: 'logout', component: LogoutComponent},

    { path: 'add_comment/:moodId', component: AddCommentComponent, canActivate: [authGuard()]},
    { path: 'choose_mood', component: ChooseMoodComponent, canActivate: [authGuard()]},
    { path: 'add_other_feedback/:moodId', component: AddOtherFeedbackComponent, canActivate: [authGuard()]},
    { path: 'add_other_feedback/poll/:pollPublishDate', component: AddOtherFeedbackComponent, canActivate: [authGuard()]},
    { path: 'add_other_feedback/poll/error/:errorMessage', component: AddOtherFeedbackComponent, canActivate: [authGuard()]},
    { path: 'add_poll_comment/:pollId', component: AddPollCommentComponent, canActivate: [authGuard()]},

    {path: 'onboarding', children:[
            { path: ':token/aboutyou', component: AboutYouComponent,},

            { path: 'invalidtoken', component: InvalidTokenComponent,},
            { path: 'renewedtoken', component: RenewedTokenComponent,},
            { path: ':token/expiredtoken', component: ExpiredTokenComponent,},
            { path: 'alreadyinteam', component: AlreadyInTeamComponent},

            { path: ':userId/settings', component: DefaultSettingsComponent, canActivate: [authGuard()]},
            { path: ':userId/teammembers', component: TeamMembersComponent, canActivate: [authGuard()]},
            { path: ':userId/ready', component: ReadyComponent, canActivate: [authGuard()]},
        ]
    },

    { path: '', component: MainComponent, canActivate: [authGuard()], children: [

            { path: 'home', component: UserHomeComponent, },
            { path: 'home/:teamId', redirectTo: '/timeline/:teamId', },

            { path: 'timeline/:teamId', component: TimelineComponent, },

            { path: 'triage', component: TaskbookTriageComponent, },
            { path: 'backlog', component: TaskbookBacklogComponent, },
            { path: 'backlog/:itemType/:itemId', component: TaskDetailsComponent, },

            { path: 'stats', component: StatsComponent, },
            { path: 'reporting', component: ReportingComponent, },

            { path: 'exports/:teamId', component: ExportsComponent, },

            { path: 'calendar/:teamId', component: CalendarComponent, },


            { path: 'setup/teammembers/:teamId', component: TeamMembersSetupComponent,},

            { path: 'setup/team/:teamId', component: TeamSetupComponent,},

            { path: 'setup/polls', component: PollsSetupComponent},

            { path: 'setup/digests', component: DigestsComponent},

            { path: 'setup/filters', component: FiltersComponent},

            { path: 'setup/out-of-office', component: OutOfOfficeSettingsComponent,
                resolve: {
                    teamMember: () => {
                        const accountService: AccountService = inject(AccountService);
                        return accountService.get();
                    }
                }
            },

            { path: 'setup/account', component: AccountSetupComponent},

            { path: 'setup/integrations', component: IntegrationsComponent},

            { path: 'setup/notification-days', component: NotificationDaysComponent},

            { path: 'setup/notification-time', component: NotificationTimeSettingsComponent},

            { path: 'setup/api/keys', component: ApiKeysComponent},

            { path: 'setup/billing', component : YearlyBillingComponent},
            { path: 'setup/billing/details', component : YearlyBillingDetailsByTeamComponent},
            { path: 'setup/billing/:teamId', component : BillingHistoryComponent},
            { path: 'setup/credit_card/new/:teamId', component : CreditCardComponent},
            { path: 'setup/credit_card/paymentvalidated/:teamId', component: PaymentValidatedComponent},
            { path: 'setup/credit_card/paymentfailed/:teamId', component: PaymentFailedComponent},

            { path: 'setup/troubleshoot/email', component: EmailDeliveryComponent, },
            { path: 'setup/troubleshoot/email/:id', component: EmailDeliveryStatusComponent, },

            { path: '**', redirectTo: '/home' }

        ]},


    { path: 'error', component: ErrorMessageComponent },
    { path: 'error/:id', component: ErrorMessageComponent },

    { path: '**', redirectTo: '/home' }
];